<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2"><a id="page_1"></a><a id="frontmatter01"></a><strong>ST. TROPEZ<br/><span class="underline">SUMMER RENTAL</span></strong></h2>
<p class="linespace"> </p>
<p class="center-para"><strong>By month or longer term.</strong></p>
<p class="para"> </p>
<p class="center-para"><strong>Charming traditional stone villa built around an ancient<br/>priory. Sunny terraces, mosaic-tiled swimming pool, arched<br/>courtyard with olive trees, lavish secluded grounds<br/>overlooking pine-treed hillside with direct view of the sea.</strong></p>
<p class="para"> </p>
<p class="center-para"><strong>Five bedrooms, five baths. Beautifully furnished. Well-equipped<br/>kitchen. Staff available if required.</strong></p>
<p class="para"> </p>
<p class="center-para"><strong>Perfectly private.</strong></p>
<p class="para"> </p>
<p class="center-para"><strong>For brochure with photographs and further details, contact:<br/>MadameSusanneLariotCannes@wanadoo.france</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?0f08e712